<template>
  <div>
    <v-dialog
      v-model="value"
      persistent
      max-width="650px"
      style="max-height=94%"
      scrollable
    >
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex order-xs2 order-md2 xs12 md12>
                <v-layout wrap>
                  <v-flex xs6>
                    <v-text-field
                      :error-messages="nameErrors"
                      v-model="$v.userForm.firstName.$model"
                      :label="
                        $t(
                          'students.massive_upload.step_3.table.edit_modal.first_name'
                        )
                      "
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      :error-messages="lastNameErrors"
                      v-model="$v.userForm.lastName.$model"
                      :label="
                        $t(
                          'students.massive_upload.step_3.table.edit_modal.last_name'
                        )
                      "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      :error-messages="levelErrors"
                      :label="
                        $t(
                          'students.massive_upload.step_3.table.edit_modal.level'
                        )
                      "
                      :items="levels"
                      outline
                      height="50"
                      return-object
                      item-text="typeLevel"
                      @change="filterGGsByLevel"
                      :dense="$vuetify.breakpoint.xsOnly"
                      v-model="$v.userForm.level.$model"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      :error-messages="ggErrors"
                      :label="
                        $t(
                          'students.massive_upload.step_3.table.edit_modal.grade_and_group'
                        )
                      "
                      :items="ggs"
                      outline
                      height="50"
                      return-object
                      :item-text="text"
                      v-model="$v.userForm.gg.$model"
                      :dense="$vuetify.breakpoint.xsOnly"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      :error-messages="personIdErrors"
                      v-model="$v.userForm.personId.$model"
                      :label="
                        $t(
                          'students.massive_upload.step_3.table.edit_modal.student_id'
                        )
                      "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 justify-start>
                    <v-radio-group
                      style="justify-content: center"
                      row
                      class="align-center"
                      v-model="$v.userForm.gender.$model"
                      color="primary"
                      :error-messages="genderErrors"
                    >
                      <v-radio
                        color="primary"
                        :label="
                          $t(
                            'students.massive_upload.step_3.table.edit_modal.male'
                          )
                        "
                        value="MALE"
                      ></v-radio>
                      <v-radio
                        color="primary"
                        :label="
                          $t(
                            'students.massive_upload.step_3.table.edit_modal.female'
                          )
                        "
                        value="FEMALE"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      v-model="$v.userForm.updatedPersonId.$model"
                      :label="
                        $t(
                          'students.massive_upload.step_3.table.edit_modal.new_student_id'
                        )
                      "
                      placeholder="No llenar si conserva la misma"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="close">
            {{ $t('students.massive_upload.step_3.table.edit_modal.cancel') }}
          </v-btn>
          <v-btn
            :disabled="working.wUpdate"
            color="primary darken-1"
            flat
            @click="submit"
          >
            {{ $t('students.massive_upload.step_3.table.edit_modal.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..."></loading>
    <success
      v-if="student != null"
      v-model="toast.success"
      text="Creación Exitosa"
    ></success>
    <success
      v-else
      v-model="toast.success"
      text="Actualización Exitosa"
    ></success>
    <error v-model="toast.failed" :text="toast.fmessage"></error>
    <editImage
      :title="userForm.image != null ? 'Editar imagen' : 'Añadir imagen'"
      v-on:loaded="processImage($event)"
      v-model="modals.image"
    ></editImage>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import error from '../Dialogs/Error.vue'
import loading from '../Dialogs/Loading.vue'
import success from '../Dialogs/Success.vue'
import editImage from '../Modals/EditImage'
export default {
  props: ['title', 'parent', 'value', 'student'],
  components: {
    loading,
    success,
    error,
    editImage,
  },
  validations: {
    userForm: {
      firstName: { required },
      lastName: { required },
      gender: { required },
      personId: { required },
      updatedPersonId: {},
      level: { required },
      gg: { required },
    },
  },
  watch: {
    value() {
      this.getLevels()
    },
  },

  mounted() {},
  data: () => ({
    modals: {
      image: false,
      parent: false,
    },
    userForm: {
      firstName: '',
      lastName: '',
      gender: '',
      personId: '',
      updatedPersonId: '',
      level: {},
      gg: {},
      pos: '',
    },
    userFormUp: {
      id: '',
      firstName: '',
      lastName: '',
      personId: '',
      updatedPersonId: '',
      gender: '',
      level: {
        id: '',
      },
      gg: {
        grade: '',
        group: '',
      },
    },
    userImg: null,
    working: {
      wUpdate: false,
      wImage: false,
    },
    toast: {
      success: false,
      failed: false,
      fmessage: 'Ups ocurrió un error',
    },
    flags: {
      updateImage: false,
      changed: false,
    },
    levels: [],
    ggs: [],
    selectedLevel: {},
    stdIdToAdd: {},
    boton2: true,
  }),
  methods: {
    text: (item) => item.grade + '' + item.group,
    setInfoToShowOnUpdate() {
      if (this.value) {
        if (this.student != null) {
          if (this.student.status == null) {
            this.boton2 = false
            this.userForm.firstName = this.student.Nombre
            this.userForm.lastName = this.student.Apellidos
            this.userForm.gender = this.student.Genero
            this.userForm.gg = this.student.Grado + this.student.Grupo
            this.userForm.personId = this.student.Matricula
            this.userForm.updatedPersonId = this.student.Matricula_Nueva
            this.userForm.pos = this.student.pos

            if (
              this.student.Genero == 'Masculino' ||
              this.student.Genero == 'MASCULINO' ||
              this.student.Genero == 'MALE'
            ) {
              this.userForm.gender = 'MALE'
            }
            if (
              this.student.Genero == 'Femenino' ||
              this.student.Genero == 'FEMENINO' ||
              this.student.Genero == 'FEMALE'
            ) {
              this.userForm.gender = 'FEMALE'
            }

            for (let index = 0; index < this.levels.length; index++) {
              if (this.levels[index].typeLevel == this.student.Nivel) {
                this.userForm.level = this.levels[index]
                var nn = this.student.Grado + this.student.Grupo

                for (
                  let index = 0;
                  index < this.userForm.level.ggs.length;
                  index++
                ) {
                  var gradogrupo =
                    this.userForm.level.ggs[index].grade +
                    this.userForm.level.ggs[index].group
                  if (gradogrupo == nn) {
                    this.userForm.gg = this.userForm.level.ggs[index]
                    break
                  }
                }
                break
              }
            }
            for (var lvl in this.levels) {
              if (this.userForm.level.id == this.levels[lvl].id) {
                this.ggs = this.levels[lvl].ggs
                break
              }
            }
          } else {
            this.boton2 = false
            this.userForm.firstName = this.student.firstName
            this.userForm.lastName = this.student.lastName
            this.userForm.gender = this.student.gender
            this.userForm.gg = this.student.grade + this.student.groupName
            this.userForm.personId = this.student.personId
            this.userForm.updatedPersonId = this.student.updatedPersonId
            this.userForm.pos = this.student.pos

            if (
              this.student.gender == 'Masculino' ||
              this.student.gender == 'MASCULINO' ||
              this.student.gender == 'MALE'
            ) {
              this.userForm.gender = 'MALE'
            }
            if (
              this.student.gender == 'Femenino' ||
              this.student.gender == 'FEMENINO' ||
              this.student.gender == 'FEMALE'
            ) {
              this.userForm.gender = 'FEMALE'
            }
            for (let index = 0; index < this.levels.length; index++) {
              if (
                this.levels[index].typeLevel == this.student.level.typeLevel
              ) {
                this.userForm.level = this.levels[index]
                var nn = this.student.grade + this.student.groupName

                for (
                  let index = 0;
                  index < this.userForm.level.ggs.length;
                  index++
                ) {
                  var gradogrupo =
                    this.userForm.level.ggs[index].grade +
                    this.userForm.level.ggs[index].group
                  if (gradogrupo == nn) {
                    this.userForm.gg = this.userForm.level.ggs[index]
                    break
                  }
                }
                break
              }
            }
            for (var lvl in this.levels) {
              if (this.userForm.level.id == this.levels[lvl].id) {
                this.ggs = this.levels[lvl].ggs
                break
              }
            }
          }
        }
      }
    },
    parent2() {
      this.boton2 = true
    },
    getLevels() {
      this.working.wUpdate = true
      this.$store
        .dispatch('tutor/getLevelsParentTool')
        .then((response) => {
          this.levels = response.data.entity.levels
          this.working.wUpdate = false
          this.setInfoToShowOnUpdate()
        })
        .catch((error) => {
          console.log(error)
          this.toast.failed = true
        })
    },

    submit() {
      this.$v.userForm.$touch()
      if (this.student.status == null) {
        if (!this.$v.userForm.$invalid) {
          this.$emit('studentchange', this.userForm)
          this.close()
        }
      } else {
        if (!this.$v.userForm.$invalid) {
          this.userFormUp.id = this.student.id
          this.userFormUp.firstName = this.userForm.firstName
          this.userFormUp.lastName = this.userForm.lastName
          this.userFormUp.personId = this.userForm.personId
          this.userFormUp.updatedPersonId = this.userForm.updatedPersonId
          this.userFormUp.gender = this.userForm.gender
          this.userFormUp.level.id = this.userForm.level.id
          this.userFormUp.gg.grade = this.userForm.gg.grade
          this.userFormUp.gg.group = this.userForm.gg.group

          this.$store
            .dispatch('student/updateStudentUpdate', this.userFormUp)
            .then((response) => {
              this.working.wUpdate = false
              this.$v.$reset()
              this.toast.success = true
              this.$emit('studentchangeUp', response.data)
              this.close()
            })
            .catch((error) => {
              this.working.wUpdate = false
              this.toast.failed = true
              if (error.status == 200) {
                this.toast.failed = error.data.message
              }
              console.log(error)
            })
        }
      }
    },

    close() {
      this.$v.$reset()
      this.flags.changed = false

      this.userForm = {
        firstName: '',
        lastName: '',
        gender: '',
        personId: '',
        updatedPersonId: '',
        level: {},
        gg: {},
        pos: '',
      }
      this.$emit('input', !this.value)
    },

    filterGGsByLevel(val) {
      this.levels.filter((item) => {
        if (item.id == val.id) {
          this.ggs = item.ggs
          this.$forceUpdate()
        }
      })
    },
    acceptS() {
      this.$emit('studentchange')
    },
    cancelS() {
      this.$emit('cancelled')
    },
  },

  computed: {
    levelErrors() {
      const errors = []
      if (!this.$v.userForm.level.$dirty) return errors
      !this.$v.userForm.level.required && errors.push('Nivel obligatorio')

      return errors
    },
    ggErrors() {
      const errors = []
      if (!this.$v.userForm.gg.$dirty) return errors
      !this.$v.userForm.gg.required && errors.push('Grado y grupo obligatorios')

      return errors
    },
    personIdErrors() {
      const errors = []
      if (!this.$v.userForm.personId.$dirty) return errors
      !this.$v.userForm.personId.required &&
        errors.push('Matrícula obligatoria')

      return errors
    },
    lastNameErrors() {
      const errors = []
      if (!this.$v.userForm.lastName.$dirty) return errors
      !this.$v.userForm.lastName.required &&
        errors.push('Apellidos obligatorios')

      return errors
    },
    nameErrors() {
      const errors = []
      if (!this.$v.userForm.firstName.$dirty) return errors
      !this.$v.userForm.firstName.required && errors.push('Nombre obligatorio')
      return errors
    },
    genderErrors() {
      const errors = []
      if (!this.$v.userForm.gender.$dirty) return errors
      !this.$v.userForm.gender.required && errors.push('Genero obligatorio')
      return errors
    },
    p1FirstNameErrors() {
      const errors = []
      if (!this.$v.userForm.parent1FirstName.$dirty) return errors
      !this.$v.userForm.parent1FirstName.required &&
        errors.push('Nombre obligatorio')
      return errors
    },
    p1LastNameErrors() {
      const errors = []
      if (!this.$v.userForm.parent1LastName.$dirty) return errors
      !this.$v.userForm.parent1LastName.required &&
        errors.push('Apellido obligatorio')
      return errors
    },
    p1Email() {
      const errors = []
      if (!this.$v.userForm.parent1Email.$dirty) return errors
      !this.$v.userForm.parent1Email.required &&
        errors.push('Email obligatorio')
      return errors
    },

    p2FirstNameErrors() {
      const errors = []
      if (this.boton2 == true) {
        if (!this.$v.userForm.parent2FirstName.$dirty) return errors
        !this.$v.userForm.parent2FirstName.required &&
          errors.push('Nombre obligatorio')
        return errors
      }
    },
    p2LastNameErrors() {
      const errors = []
      if (this.boton2 == true) {
        if (!this.$v.userForm.parent2LastName.$dirty) return errors
        !this.$v.userForm.parent2LastName.required &&
          errors.push('Apellido obligatorio')
        return errors
      }
    },
    p2Email() {
      const errors = []
      const emailRegex =
        /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i
      if (this.boton2 == true) {
        if (!this.$v.userForm.parent2Email.$dirty) return errors
        !this.$v.userForm.parent2Email.required &&
          errors.push('Email obligatorio')
        return errors
      }
    },
  },
}
</script>

<style>
.no-properties {
  width: 0% !important;
  height: 0% !important;
}
.danger {
  background-color: #f5bcc0;
}
</style>
